import type { Address } from '@helloextend/extend-api-client'

export const formatAddress = (address?: Address): string => {
  if (!address) return 'None'
  return `${address.address1}\n${address.address2 ? `${address.address2}\n` : ''}${address.city}, ${
    address.provinceCode
  }, ${address.postalCode}`
}
